// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `data-field-view {
  display: block;
}

.fi-data-field-view {
  display: block;
}
.fi-data-field-view:not(.fi-data-field-view-not-empty) {
  display: none;
}`, "",{"version":3,"sources":["webpack://./Source/app/data-field/data-field-view/data-field-view.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;;AAEA;EACI,cAAA;AACJ;AACI;EACI,aAAA;AACR","sourcesContent":["data-field-view {\r\n    display: block;\r\n}\r\n\r\n.fi-data-field-view {\r\n    display: block;\r\n\r\n    &:not(.fi-data-field-view-not-empty) {\r\n        display: none;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
